<template>
  <div class="heartbeat-section">
    <!-- WEB Device -->
    <div class="notification-device">
      <!-- Heading -->
      <div class="notification-header">
        <h2 class="notification-title">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967ZM0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.833252 9.99967C0.833252 9.53944 1.20635 9.16634 1.66659 9.16634H18.3333C18.7935 9.16634 19.1666 9.53944 19.1666 9.99967C19.1666 10.4599 18.7935 10.833 18.3333 10.833H1.66659C1.20635 10.833 0.833252 10.4599 0.833252 9.99967Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50011 9.99967C7.55722 12.562 8.43846 15.029 9.99992 17.0407C11.5614 15.029 12.4426 12.562 12.4997 9.99967C12.4426 7.43731 11.5614 4.97038 9.99992 2.95867C8.43846 4.97038 7.55722 7.43731 7.50011 9.99967ZM9.99992 1.66634L9.38463 1.10432C7.16399 3.53543 5.90201 6.69039 5.83343 9.98232C5.83319 9.99389 5.83319 10.0055 5.83343 10.017C5.90201 13.309 7.16399 16.4639 9.38463 18.895C9.54251 19.0679 9.76582 19.1663 9.99992 19.1663C10.234 19.1663 10.4573 19.0679 10.6152 18.895C12.8358 16.4639 14.0978 13.309 14.1664 10.017C14.1666 10.0055 14.1666 9.99389 14.1664 9.98232C14.0978 6.69039 12.8358 3.53543 10.6152 1.10432L9.99992 1.66634Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          My HeartBeat<strong>Central</strong>&nbsp;Settings
        </h2>
      </div>
      <!-- Heading END -->
      <b-link @click="handleHeartBeatProfileClick">
        https://heartbeatfam.com/{{ heartBeatName }}
      </b-link>
      <div style="margin-top: 15px">
        <toggle-single
            id="research-data"
            :toggle-model="optInResearch"
            label-name="OptIn to Anonymized Research?"
            label-info="Empower our collective understanding: Opting in to share your data for research contributes to advancing knowledge and improving outcomes for all."
            @toggle-click="handleToggleOptinResearch"
        />
        <toggle-single
            id="taking-currently"
            :toggle-model="manageStageDementia"
            label-name="Manage Stages of Dementia (if applicable)"
            label-info="Share your current stage of dementia to facilitate personalized and effective care tailored to your unique needs.?"
            @toggle-click="handleToggleManageDementiaStage"
        />
        <drop-down-field
            field-key="stage_dementia"
            field-name="Dementia Stage"
            :disabled="!manageStageDementia"
            :options-json="stagesConditionsJSON"
            select-word="Stage"
            :selected-value="stageDementia"
            @selected-option="handleDropDownSelect"
        />
      </div>
      <div>
        <div>
          <permission-table v-if="false"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="foot">
          <b-button
              variant="primary btn-round-fill"
              type="submit"
              @click.prevent="handleUpdateHeartBeatSettings"
          >Save Changes
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSingle from "@/components/common/toggleSingle";
import DropDownField from "@/components/common/dropDownField";
import PermissionTable from "./permissionTable";
import stagesConditionsJSON from "@/assets/heartbeat/json/stagesConditions.json"

import { mapGetters } from "vuex";
export default {
  name: "Settings_HeartBeat",
  components: {
    DropDownField,
    PermissionTable,
    ToggleSingle
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    heartBeatName() {
      return this.profile && this.profile.heartbeat
        ? this.profile.heartbeat.profileName
        : null;
    }
  },
  methods: {
    handleActivation() {
      //Set Up Data from profile
      this.setDataFromProfile();
    },
    setDataFromProfile(){
      //@ToDo- CleanUp

    },
    handleHeartBeatProfileClick() {
      this.$router.push(`/heartbeat/${this.heartBeatName}`);
    },
    handleToggleOptinResearch(){
      this.optInResearch = !this.optInResearch;
    },
    handleToggleManageDementiaStage(){
      this.manageStageDementia = !this.manageStageDementia;
    },
    handleDropDownSelect({key, option}){
      this.stageDementia = option.value;
    },
    handleUpdateHeartBeatSettings() {
      let payload = {
        manageStageDementia:this.manageStageDementia,
        optInResearch: this.optInResearch,
        stageDementia: this.stageDementia
      };

      this.$store.dispatch("user/updateHeartBeatSettings", payload).then(res => {

        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            this.$store.dispatch("user/showNotification", {
              title: "Changes Saved Successfully",
              description: "Your changes has been saved successfully",
              variant: "success"
            });
          });
        } else {
          this.$store.dispatch("user/showNotification", {
            title: "Ooops! could not save your profile.",
            description: "Your changes were not saved",
            variant: "error"
          });
        }
      });
    },
  },
  data() {
    return {
      stagesConditionsJSON,
      stageDementia: this.profile && this.profile.heartbeat && this.profile.heartbeat.settings && this.profile.heartbeat.settings.stageDementia !== undefined  ?
          this.profile.heartbeat.settings.stageDementia: null,
      manageStageDementia: this.profile && this.profile.heartbeat && this.profile.heartbeat.settings && this.profile.heartbeat.settings.manageStageDementia !== undefined  ?
          this.profile.heartbeat.settings.manageStageDementia: null,
      optInResearch: this.profile && this.profile.heartbeat && this.profile.heartbeat.settings && this.profile.heartbeat.settings.optInResearch !== undefined  ?
          this.profile.heartbeat.settings.optInResearch: null,
    };
  }
};
</script>

<style lang="scss" scoped>
.heartbeat-section {
  font-family: "Nunito", sans-serif;
  .notification-device {
    position: relative;
    margin-top: 32px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ddd;
    .notification-header {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      @media (max-width: 500px) {
        flex-direction: column;
      }
      .notification-title {
        font-weight: 600;
        font-size: 14px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #474d52;

        span {
          padding-right: 8px;
        }
      }
      .notification-des {
        span {
          cursor: pointer;
        }
      }
      h3 {
        margin-left: 16px;
        font-weight: 600;
        font-size: 12px;

        display: flex;
        align-items: center;
        color: #474d52;
        span {
          padding-right: 8px;
        }
      }
    }

    .notification {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 16px;

      .notification-content {
        margin-left: 14px;
        cursor: pointer;
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 12px;

          color: #8d99a0;
          margin: 0;
        }
        h6 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;

          display: flex;
          align-items: center;
          color: #474d52;
          @media (max-width: 874px) {
            margin-bottom: 0px;
          }
        }
      }
      .toggler {
        @media (max-width: 874px) {
          margin-bottom: 10px;
          margin-left: 15px;
        }
        position: relative;
        display: inline-block;
        width: 36px;
        height: 17px;
        background-color: #e8ebec;
        border-radius: 24px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider {
        position: absolute;
        content: "";
        height: 23px;
        width: 23px;
        left: -3px;
        bottom: -3px;
        background: #8d99a0;

        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
      }
      .bg {
        background: #dde5fe;
      }
      .btns {
        left: 50%;
        background-color: var(--theme-color);
      }
    }
  }
  .btn-round-fill {
    width: 166px;
    height: 40px;
    margin-top: 24px;
    // margin-bottom: 24px;
    // margin-bottom: 80px;
  }
  .foot {
    // border-top: 1px solid #ddd;
    margin-top: 24px;
    margin-bottom: 80px;
  }
}
</style>
